import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const formatError = (detail) => {
    if (!detail) return "Login failed";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
    return String(detail);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.access_token) localStorage.setItem("hc_token", data.access_token);
      toast.success("Welcome back");
      nav("/admin");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center bg-[#FAF4F1] px-4 py-12">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-2xl shadow-[#5979A9]/15 border border-[#F0EAE6] p-8 sm:p-10">
        <div className="flex flex-col items-center mb-7">
          <img src="/images/logo.png" alt="Himalayan Cafe" className="h-16 w-16 rounded-full bg-[#FAF4F1] p-1" />
          <h1 className="font-serif-display text-3xl text-[#5979A9] mt-4">Admin Sign In</h1>
          <p className="text-sm text-[#4A5568] mt-1">Himalayan Cafe management</p>
        </div>
        <form onSubmit={onSubmit} className="space-y-5">
          <div>
            <label className="block text-xs uppercase tracking-[0.2em] text-[#5979A9]/80 mb-2 font-semibold">Email</label>
            <input data-testid="admin-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                   className="w-full bg-transparent border-b-2 border-[#F0EAE6] focus:border-[#E05947] outline-none py-2.5 text-[#2D3748]"/>
          </div>
          <div>
            <label className="block text-xs uppercase tracking-[0.2em] text-[#5979A9]/80 mb-2 font-semibold">Password</label>
            <input data-testid="admin-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                   className="w-full bg-transparent border-b-2 border-[#F0EAE6] focus:border-[#E05947] outline-none py-2.5 text-[#2D3748]"/>
          </div>
          <button data-testid="admin-login-button" type="submit" disabled={loading} className="btn-primary w-full">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
